import { Box } from 'ink';
import { ReactNode } from 'react';
import ErrorDisplay from './ErrorDisplay';
import LoadingText from './LoadingText';
import SelectTable, { type Item } from './SelectTable';
import { DataItem } from './table/tableTypes';

type Status = 'loading' | 'show-builds' | 'no-builds' | 'error' | 'selected';

type BuildTableLayoutProps<T extends DataItem> = {
  builds: T[];
  commandUsed: string;
  error: Error | null;
  header?: ReactNode;
  footer?: ReactNode;
  loadingText?: string;
  noBuildsContent: ReactNode;
  onSelect: (item: Item<T>) => void;
  status: Status;
};

export default function BuildTableLayout<T extends DataItem>({
  builds,
  commandUsed,
  error,
  footer,
  header,
  loadingText,
  noBuildsContent,
  onSelect,
  status,
}: BuildTableLayoutProps<T>) {
  switch (status) {
    case 'loading':
      return <LoadingText text={loadingText} />;

    case 'error':
      return (
        <ErrorDisplay
          commandUsed={commandUsed}
          error={error ?? new Error('Unknown error')}
        />
      );

    case 'no-builds':
      return <>{noBuildsContent}</>;

    case 'show-builds':
      return (
        <Box flexDirection="column">
          {header}
          <SelectTable data={builds} onSelect={onSelect} />
          {footer}
        </Box>
      );

    case 'selected':
      return null;

    default:
      return null;
  }
}
